<axs-modal #modal class="discover-modal" [axsSize]="'medium'" *ngIf="isOpen">
  <dialog #dialog class="modal_container">
    <axs-modal-close>
      <ngx-axs-button
        [axsText]="commonContent?.close"
        axsType="supplementary"
        axsTheme="black"
        axsIconType="close"
        (axsClick)="closeModal()"
      />
    </axs-modal-close>

    <axs-modal-content aria-label="Discover Modal Content">
      <div class="discover-modal__content">
        <h3 class="discover-modal__title text-title-2 weight-bold">
          {{ discoverModalContent?.discoverlinkmodal }}
        </h3>

        <p class="discover-modal__description text-body-2">
          {{ discoverModalContent?.discoverlinkmodaldesc }}
        </p>

        <div class="discover-modal__graphic" aria-hidden="true">
          <img
            class="discover-modal__graphic-img"
            src="assets/svgs/Shift-The-BETR-Chart.svg"
            alt=""
          />
        </div>

        <p class="discover-modal__learn-more">
          <span class="discover-modal__learn-more-label text-body-2 weight-bold">{{ discoverModalContent?.wanttolearnmore }}</span>
          <a
            class="discover-modal__learn-more-link text-body-2"
            [href]="researchSummaryLink"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ discoverModalContent?.readsummaryresearch }}
            <img
              class="discover-modal__external-icon"
              src="assets/svgs/link-outside.svg"
              alt=""
              aria-hidden="true"
            />
          </a>
        </p>

        <div><axs-hr axsThickness="1"></axs-hr></div>

        <p class="discover-modal__notes text-body-4">
          <span class="weight-bold">{{ discoverModalContent?.notes }}</span>
          {{ discoverModalContent?.notesdesc }}
        </p>

        <p class="discover-modal__source text-body-4">
          <span class="weight-bold">{{ discoverModalContent?.source }}</span>
          {{ discoverModalContent?.vanguard }}
        </p>
      </div>
    </axs-modal-content>
  </dialog>
</axs-modal>
